<ng-container *ngIf="permConfig.isViewAllowed">
    <div class="container-fluid">
        <app-page-title title="Data import"></app-page-title>
        <div class="row">
            <div class="col-md-12">
                <ul ngbNav #justifiednav="ngbNav" [(activeId)]="activeId" class="nav-pills bg-light rounded nav"
                    (activeIdChange)="onTabChange($event)">
                    <li [ngbNavItem]="1" (click)="activeId = 1">
                        <a ngbNavLink>
                            <span class="d-block d-sm-none"><i class="fas fa-receipt"></i></span>
                            <span class="d-none d-sm-block">AWB</span>
                        </a>
                        <ng-template ngbNavContent>
                            <ng-template [ngTemplateOutlet]="AWB"> </ng-template>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="2" (click)="activeId = 2">
                        <a ngbNavLink>
                            <span class="d-block d-sm-none"><i class="fas fa-receipt"></i></span>
                            <span class="d-none d-sm-block">ODA</span>
                        </a>
                        <ng-template ngbNavContent>
                            <ng-template [ngTemplateOutlet]="ODA"> </ng-template>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="3" (click)="activeId = 3">
                        <a ngbNavLink>
                            <span class="d-block d-sm-none"><i class="fas fa-receipt"></i></span>
                            <span class="d-none d-sm-block">Vendor AWB</span>
                        </a>
                        <ng-template ngbNavContent>
                            <ng-template [ngTemplateOutlet]="VendorAWB"> </ng-template>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="4" (click)="activeId = 4" *ngIf="permConfig.isAddAllowed">
                        <a ngbNavLink>
                            <span class="d-block d-sm-none"><i class="fas fa-receipt"></i></span>
                            <span class="d-none d-sm-block">Charges</span>
                        </a>
                        <ng-template ngbNavContent>
                            <ng-template [ngTemplateOutlet]="Charges"> </ng-template>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="5" (click)="activeId = 5" *ngIf="permConfig.isAddAllowed">
                        <a ngbNavLink>
                            <span class="d-block d-sm-none"><i class="fas fa-receipt"></i></span>
                            <span class="d-none d-sm-block">Pincodes</span>
                        </a>
                        <ng-template ngbNavContent>
                            <ng-template [ngTemplateOutlet]="PincodeTab"> </ng-template>
                        </ng-template>
                    </li>
                </ul>
                <div class="card">
                    <div class="card-body">
                        <div [ngbNavOutlet]="justifiednav"></div>
                    </div>
                </div>
                <ng-template #AWB>
                    <form [formGroup]="awbForm">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label class="form-label">Type <span class="mandatory">*</span> </label>
                                    <ng-select [items]="awbTypeList" bindLabel="name" [bindValue]="'id'"
                                        formControlName="ddlType" [appendTo]="'body'" [openOnEnter]="false"
                                        [clearable]="false" placeholder="Select"
                                        [ngClass]="{'is-invalid':(isFormSubmitted || awbForm.get('ddlType').touched) && awbForm.get('ddlType').errors}">
                                    </ng-select>
                                    <div *ngIf=" (isFormSubmitted || awbForm.get('ddlType').touched) && awbForm.get('ddlType').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="awbForm.get('ddlType').errors.required">Type is Required.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2 mt-3">
                                <button type="button" class="btn btn-primary btn-sm d-flex mt-1"
                                    (click)="downloadFormatFile(filePathObj.awb)">
                                    <i class="bx bx-download font-size-15 me-1"></i> Download
                                </button>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <div class="input-group">
                                        <input type="file" id="importawbfile" class="form-control form-control-sm"
                                            accept=".xlsx" (change)="onChangeFileSelect($event)" />
                                        <button type="button" class="btn btn-primary btn-sm d-flex"
                                            (click)="uploadAWBFile();">
                                            <i class="bx bx-upload font-size-15 me-1"></i>Upload
                                        </button>
                                    </div>
                                    <!-- <ng-container *ngIf="showProgressBar">
                                        <div class="progress mt-2">
                                            <div class="progress-bar progress-bar-striped" role="progressbar"
                                                [style.width.%]="progress" [attr.aria-valuenow]="progress"
                                                aria-valuemin="0" aria-valuemax="100">
                                                {{progress}}%
                                            </div>
                                        </div>
                                    </ng-container> -->
                                </div>
                            </div>
                        </div>
                    </form>
                </ng-template>
                <ng-template #ODA>
                    <form [formGroup]="odaForm">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label class="form-label" for="chargetype">Type<span
                                            class="mandatory">*</span></label>
                                    <ng-select id="chargetype" [items]="odaTypeList" formControlName="ddlType"
                                        bindLabel="name" [bindValue]="'name'" placeholder="Select" aria-required="true"
                                        [appendTo]="'body'" [openOnEnter]="false" (change)="onChangeChargeType()"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || odaForm.get('ddlType')?.touched) && odaForm.get('ddlType').errors}">
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || odaForm.get('ddlType')?.touched) && odaForm.get('ddlType').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="odaForm.get('ddlType').errors.required">Charge Type is
                                            required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2" *ngIf="chargeType == 'Customer'">
                                <div class="mb-2">
                                    <label class="form-label" for="customer">Customer<span
                                            class="mandatory">*</span></label>
                                    <ng-select id="customer" [items]="customerList" formControlName="ddlCustomer"
                                        bindLabel="name" [bindValue]="'id'" placeholder="Select" [appendTo]="'body'"
                                        [openOnEnter]="false"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || odaForm.get('ddlCustomer')?.touched) && odaForm.get('ddlCustomer').errors}">
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || odaForm.get('ddlCustomer')?.touched) && odaForm.get('ddlCustomer').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="odaForm.get('ddlCustomer').errors.required">Customer is
                                            Required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2" *ngIf="chargeType == 'Vendor'">
                                <div class="mb-2">
                                    <label class="form-label" for="vendor">Vendor<span
                                            class="mandatory">*</span></label>
                                    <ng-select id="vendor" [items]="vendorList" formControlName="ddlVendor"
                                        bindLabel="name" [bindValue]="'id'" placeholder="Select" [appendTo]="'body'"
                                        [openOnEnter]="false"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || odaForm.get('ddlVendor')?.touched) && odaForm.get('ddlVendor').errors}">
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || odaForm.get('ddlVendor')?.touched) && odaForm.get('ddlVendor').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="odaForm.get('ddlVendor').errors.required">Vendor is
                                            Required</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-2 mt-3">
                                <button type="button" class="btn btn-primary btn-sm d-flex mt-1"
                                    (click)="downloadFormatFile(filePathObj.oda)">
                                    <i class="bx bx-download font-size-15 me-1"></i> Download
                                </button>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <div class="input-group">
                                        <input id="importoda" type="file" class="form-control form-control-sm"
                                            accept=".xlsx" (change)="onChangeFileSelect($event)" />
                                        <button type="button" class="btn btn-primary btn-sm d-flex"
                                            (click)="uploadODAFile()">
                                            <i class="bx bx-upload font-size-15 me-1"></i>
                                            Upload
                                        </button>
                                    </div>
                                    <!-- <ng-container *ngIf="showProgressBar">
                                        <div class="progress mt-2">
                                            <div class="progress-bar progress-bar-striped" role="progressbar"
                                                [style.width.%]="progress" [attr.aria-valuenow]="progress"
                                                aria-valuemin="0" aria-valuemax="100">
                                                {{progress}}%
                                            </div>
                                        </div>
                                    </ng-container> -->
                                </div>
                            </div>
                        </div>
                    </form>
                </ng-template>
                <ng-template #VendorAWB>
                    <form [formGroup]="vendorAWBForm">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label class="form-label" for="vendor">Vendor<span
                                            class="mandatory">*</span></label>
                                    <ng-select id="vendor" [items]="vendorList" formControlName="ddlVendor"
                                        bindLabel="name" [bindValue]="'id'" placeholder="Select" [appendTo]="'body'"
                                        [openOnEnter]="false"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || vendorAWBForm.get('ddlVendor')?.touched) && vendorAWBForm.get('ddlVendor').errors}">
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || vendorAWBForm.get('ddlVendor')?.touched) && vendorAWBForm.get('ddlVendor').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="vendorAWBForm.get('ddlVendor').errors.required">Vendor is
                                            Required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2 mt-3">
                                <button type="button" class="btn btn-primary btn-sm d-flex mt-1"
                                    (click)="downloadFormatFile(filePathObj.oda)">
                                    <i class="bx bx-download font-size-15 me-1"></i> Download
                                </button>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <div class="input-group">
                                        <input id="importvendorawb" type="file" class="form-control form-control-sm"
                                            accept=".xlsx" (change)="onChangeFileSelect($event)" />
                                        <button type="button" class="btn btn-primary btn-sm d-flex"
                                            (click)="uploadAWBFile('vendorAWB')">
                                            <i class="bx bx-upload font-size-15 me-1"></i>
                                            Upload
                                        </button>
                                    </div>
                                    <!-- <ng-container *ngIf="showProgressBar">
                                        <div class="progress mt-2">
                                            <div class="progress-bar progress-bar-striped" role="progressbar"
                                                [style.width.%]="progress" [attr.aria-valuenow]="progress"
                                                aria-valuemin="0" aria-valuemax="100">
                                                {{progress}}%
                                            </div>
                                        </div>
                                    </ng-container> -->
                                </div>
                            </div>
                        </div>
                    </form>
                </ng-template>
                <ng-template #Charges>
                    <form [formGroup]="chargesForm">
                        <div class="row">
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-2">
                                                <div class="mb-2">
                                                    <label for="chargetype" class="form-label">Charge Type <span
                                                            class="mandatory">
                                                            *</span></label>
                                                    <ng-select id="chargetype" placeholder="Select"
                                                        [items]="chargeTypeList" [appendTo]="'body'"
                                                        [openOnEnter]="false" formControlName="ddlChargeType"
                                                        bindLabel="ratetype" [bindValue]="'id'"
                                                        (change)="onChangeType()"
                                                        [ngClass]="{'is-invalid': (isFormSubmitted || chargesForm.get('ddlChargeType')?.touched) && chargesForm.get('ddlChargeType').errors}"
                                                        appEnterDirective [onEnterKey]="useEnterKey">
                                                    </ng-select>
                                                    <div *ngIf="(isFormSubmitted || chargesForm.get('ddlChargeType')?.touched) && chargesForm.get('ddlChargeType').errors"
                                                        class="invalid-feedback">
                                                        <span
                                                            *ngIf="chargesForm.get('ddlChargeType').errors.required">Charge
                                                            Type
                                                            is Required</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2" *ngIf="showCategory">
                                                <div class="mb-2">
                                                    <label for="chargeCategoryType" class="form-label">Category<span
                                                            *ngIf="isCategoryMand" class="mandatory">*</span></label>
                                                    <ng-select id="chargeCategoryType" placeholder="Select"
                                                        [items]="chargeCategoriesList" [appendTo]="'body'"
                                                        [openOnEnter]="false" formControlName="ddlChargeCategory"
                                                        bindLabel="ratecategory" [bindValue]="'id'"
                                                        (change)="onChangeChargeCategory()"
                                                        [ngClass]="{'is-invalid': (isFormSubmitted || chargesForm.get('ddlChargeCategory')?.touched) && chargesForm.get('ddlChargeCategory').errors}"
                                                        appEnterDirective [onEnterKey]="useEnterKey">
                                                    </ng-select>
                                                    <div *ngIf="(isFormSubmitted || chargesForm.get('ddlChargeCategory')?.touched) && chargesForm.get('ddlChargeCategory').errors"
                                                        class="invalid-feedback">
                                                        <span
                                                            *ngIf="chargesForm.get('ddlChargeCategory').errors.required">Category
                                                            is Required</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="mb-2">
                                                    <label for="surchargeType" class="form-label">Surcharge Type <span
                                                            class="mandatory">*</span></label>
                                                    <ng-select id="surchargeType" placeholder="Select"
                                                        [items]="surchargeTypeList" [appendTo]="'body'"
                                                        [openOnEnter]="false" formControlName="ddlSurchargeType"
                                                        bindLabel="name" [bindValue]="'name'"
                                                        [ngClass]="{'is-invalid': (isFormSubmitted || chargesForm.get('ddlSurchargeType')?.touched) && chargesForm.get('ddlSurchargeType').errors}"
                                                        appEnterDirective [onEnterKey]="useEnterKey">
                                                    </ng-select>
                                                    <div *ngIf="(isFormSubmitted || chargesForm.get('ddlSurchargeType')?.touched) && chargesForm.get('ddlSurchargeType').errors"
                                                        class="invalid-feedback">
                                                        <span
                                                            *ngIf="chargesForm.get('ddlSurchargeType').errors.required">Surcharge
                                                            Type is Required</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <ng-container *ngIf="showDownloadBtn">
                                                <div class="col-md-2">
                                                    <label class="form-label mb-0"></label>
                                                    <div class="">
                                                        <button type="button" class="btn btn-primary btn-sm"
                                                            (click)="downloadChargeFormatFile()" appEnterDirective
                                                            [onEnterKey]="useEnterKey">
                                                            <i
                                                                class="bx bx-download font-size-16 align-middle me-2"></i>
                                                            Download
                                                        </button>
                                                    </div>
                                                </div>
                                            </ng-container>

                                        </div>
                                        <div class="row">
                                            <div class="col-md-2">
                                                <div class="mb-2">
                                                    <label for="fromDate" class="form-label">From Date <span
                                                            class="mandatory">*</span></label>
                                                    <input id="fromDate" class="form-control form-control-sm"
                                                        type="date" formControlName="txtFromDate" max="9999-12-31"
                                                        [ngClass]="{'is-invalid': (isFormSubmitted || chargesForm.get('txtFromDate')?.touched) && chargesForm.get('txtFromDate').errors}"
                                                        appEnterDirective [onEnterKey]="useEnterKey">
                                                    <div *ngIf="(isFormSubmitted || chargesForm.get('txtFromDate')?.touched) && chargesForm.get('txtFromDate').errors"
                                                        class="invalid-feedback">
                                                        <span
                                                            *ngIf="chargesForm.get('txtFromDate').errors.required">Date
                                                            is
                                                            Required</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="mb-2">
                                                    <label for="toDate" class="form-label">To Date <span
                                                            class="mandatory">*</span></label>
                                                    <input id="toDate" class="form-control form-control-sm" type="date"
                                                        formControlName="txtToDate" max="9999-12-31"
                                                        [ngClass]="{'is-invalid': (isFormSubmitted || chargesForm.get('txtToDate')?.touched) && chargesForm.get('txtToDate').errors}"
                                                        appEnterDirective [onEnterKey]="useEnterKey">
                                                    <div *ngIf="(isFormSubmitted || chargesForm.get('txtToDate')?.touched) && chargesForm.get('txtToDate').errors"
                                                        class="invalid-feedback">
                                                        <span *ngIf="chargesForm.get('txtToDate').errors.required">Date
                                                            is
                                                            Required</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <ng-container *ngIf="showBands">
                                                <div class="col-md-2">
                                                    <div class="mb-2">
                                                        <label for="chargeBands" class="form-label"> Bands <span
                                                                class="mandatory">*</span></label>
                                                        <ng-select id="chargeBands" [items]="chargeBandList"
                                                            bindLabel="rateband" placeholder="Select" [bindValue]="'id'"
                                                            [appendTo]="'body'" [openOnEnter]="false"
                                                            formControlName="ddlChargeBand"
                                                            [ngClass]="{'is-invalid': (isFormSubmitted || chargesForm.get('ddlChargeBand')?.touched) && chargesForm.get('ddlChargeBand').errors}"
                                                            appEnterDirective [onEnterKey]="useEnterKey">
                                                        </ng-select>
                                                        <div *ngIf="(isFormSubmitted || chargesForm.get('ddlChargeBand')?.touched) && chargesForm.get('ddlChargeBand').errors"
                                                            class="invalid-feedback">
                                                            <span
                                                                *ngIf="chargesForm.get('ddlChargeBand').errors.required">
                                                                Band is
                                                                Required</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngIf="showCustomer">
                                                <div class="col-md-2">
                                                    <div class="mb-2">
                                                        <label for="customerCharge" class="form-label">Customer <span
                                                                class="mandatory">*</span></label>
                                                        <ng-select id="customerCharge" [items]="customerList"
                                                            bindLabel="name" placeholder="Select" [bindValue]="'id'"
                                                            [appendTo]="'body'" [openOnEnter]="false"
                                                            formControlName="ddlCustomer"
                                                            [ngClass]="{'is-invalid': (isFormSubmitted || chargesForm.get('ddlCustomer')?.touched) && chargesForm.get('ddlCustomer').errors}"
                                                            appEnterDirective [onEnterKey]="useEnterKey">
                                                        </ng-select>
                                                        <div *ngIf="(isFormSubmitted || chargesForm.get('ddlCustomer')?.touched) && chargesForm.get('ddlCustomer').errors"
                                                            class="invalid-feedback">
                                                            <span
                                                                *ngIf="chargesForm.get('ddlCustomer').errors.required">Customer
                                                                is
                                                                Required</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngIf="showVendor">
                                                <div class="col-md-2">
                                                    <div class="mb-2">
                                                        <label for="headerVendor" class="form-label">Vendor<span
                                                                class="mandatory">*</span></label>
                                                        <ng-select id="headerVendor" [items]="vendorList"
                                                            bindLabel="name" placeholder="Select" [bindValue]="'id'"
                                                            [appendTo]="'body'" [openOnEnter]="false"
                                                            formControlName="ddlVendor"
                                                            [ngClass]="{'is-invalid': (isFormSubmitted || chargesForm.get('ddlVendor')?.touched) && chargesForm.get('ddlVendor').errors}"
                                                            appEnterDirective [onEnterKey]="useEnterKey">
                                                        </ng-select>
                                                        <div *ngIf="(isFormSubmitted || chargesForm.get('ddlVendor')?.touched) && chargesForm.get('ddlVendor').errors"
                                                            class="invalid-feedback">
                                                            <span
                                                                *ngIf="chargesForm.get('ddlVendor').errors.required">Vendor
                                                                is
                                                                Required</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <label class="form-label">( <small for=""><i
                                                            class="mdi mdi-information">Note: xls are only
                                                            allowed.</i></small> )</label>
                                                <div class="input-group">
                                                    <input type="file" id="importcharges"
                                                        class="form-control form-control-sm" accept=".xlsx,.xls"
                                                        formControlName="fileControl"
                                                        (change)="onChangeFileSelect($event)"
                                                        [ngClass]="{'is-invalid': (isFormSubmitted || chargesForm.get('fileControl')?.touched) && chargesForm.get('fileControl').errors}"
                                                        appEnterDirective [onEnterKey]="useEnterKey">
                                                    <button type="button" class="btn btn-primary btn-sm"
                                                        (click)="uploadCharges()" appEnterDirective
                                                        [onEnterKey]="useEnterKey">
                                                        <i class="bx bx-upload font-size-16 align-middle me-2"></i>
                                                        Upload
                                                    </button>
                                                    <div *ngIf="(isFormSubmitted || chargesForm.get('fileControl')?.touched) && chargesForm.get('fileControl').errors"
                                                        class="invalid-feedback">
                                                        <span
                                                            *ngIf="chargesForm.get('fileControl').errors.required">Select
                                                            file to
                                                            upload</span>
                                                    </div>
                                                </div>
                                                <!-- <div *ngIf="showProgressBar" class="progress mt-2">
                                                    <div class="progress-bar progress-bar-striped" role="progressbar"
                                                        [style.width.%]="progress" [attr.aria-valuenow]="progress"
                                                        aria-valuemin="0" aria-valuemax="100">
                                                        {{progress}}%
                                                    </div>
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </ng-template>
                <ng-template #PincodeTab>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <div class="input-group">
                                        <input id="importpincode" type="file" class="form-control form-control-sm"
                                            accept=".xlsx" (change)="onChangeFileSelect($event)" />
                                        <button type="button" class="btn btn-primary btn-sm d-flex"
                                            (click)="uploadPincodeFile()">
                                            <i class="bx bx-upload font-size-15 me-1"></i>
                                            Upload
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <button type="button" class="btn btn-primary btn-sm d-flex"
                                    (click)="downloadFormatFile(filePathObj.pincodes)">
                                    <i class="bx bx-download font-size-15 me-1"></i> Download Sample File
                                </button>
                            </div>
                        </div>
                </ng-template>
                <!-- <div class="col-md-12" *ngIf="activeId != 1 && activeId != 2 && activeId != 3 && activeId != 4">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="d-flex">
                                            <span class="mx-2 text-primary">Total:
                                                <strong>{{recordStatusObj.totalRecord}}</strong></span>
                                            <span class="mx-2 text-success">Valid:
                                                <strong>{{recordStatusObj.validRecord}}</strong></span>
                                            <span class="mx-2 text-danger">Invalid:
                                                <strong>{{recordStatusObj.invalidRecord}}</strong></span>
                                        </div>
                                        <button type="button" class="btn btn-primary btn-sm"
                                            [disabled]="isProcessDataDisabled()">
                                            <i class="mdi mdi-plus" (click)="porcessImport()">Process Data</i>
                                        </button>
                                    </div>
                                </div>
                                <div *ngIf="activeId === 1 || activeId === 3">
                                    <div class="row mt-2">
                                        <div class="col-md-12 grid-container mb-2">
                                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                                class="ag-theme-balham" [rowData]="rowDataAWB"
                                                [columnDefs]="columnDefsAWB" [animateRows]="true" [context]="context"
                                                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
                                                [suppressMenuHide]="true" [enableCellTextSelection]="true"
                                                [pagination]="true" (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="activeId === 2">
                                    <div class="row mt-2">
                                        <div class="col-md-12 grid-container mb-2">
                                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                                class="ag-theme-balham" [rowData]="rowDataODA"
                                                [columnDefs]="columnDefsODA" [animateRows]="true" [context]="context"
                                                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
                                                [suppressMenuHide]="true" [enableCellTextSelection]="true"
                                                [pagination]="true" (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="activeId === 4">
                                    <div class="row mt-2">
                                        <div class="col-md-12 grid-container mb-2">
                                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                                class="ag-theme-balham" [rowData]="rowDataCharges"
                                                [columnDefs]="columnDefsCharges" [animateRows]="true"
                                                [context]="context" [defaultColDef]="defaultColDef"
                                                [gridOptions]="gridOptions" [suppressMenuHide]="true"
                                                [enableCellTextSelection]="true" [pagination]="true"
                                                (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="row" *ngIf="jobAdded"> 
            <div>
                <span class="d-block p-3 rounded shadow-sm" style="background-color: #d4f1f9; color: #0a5275;">
                    ✅ The job has been successfully added to the process queue.  
                    <a routerLink='/jobs' style="color: #007bff; font-weight: bold; margin-left: 8px; text-decoration: none;">
                        View Job Queue
                    </a>
                </span>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!permConfig.isViewAllowed">
    <app-forbidden></app-forbidden>
</ng-container>

